import React, { Component } from "react";
import ReactDOM from "react-dom";

import { ENDPOINTS } from "../../constants/endpoints";

class SubscriptionPayment extends Component {
  constructor(props) {
    super(props);
    this.state = { sub_count: 1, ...props };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {}

  componentDidMount() {
    // uncomment below line to generate a image in the background
    // this.props.generateImage(this.state.product_id, this.state.setno);
  }

  //amount = this.props.amount;

  createOrder = (data, actions) => {
    if (this.state.pg_order_id) return this.state.pg_order_id;
    const payload = {
      sub_id: this.props.sub_id,
      sub_count: this.props.sub_count,
      price: this.props.price,
      amount: this.props.amount
    };
    let uri = ENDPOINTS.user_subscriptions.create.uri;
    return fetch(uri, {
      method: ENDPOINTS.user_subscriptions.create.method,
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ pg_order_id: response.pg_order_id });
        return response.pg_order_id;
      });
  };

  onApprove = (data, actions) => {
    localStorage.setItem("isSubscriptionPaid", "true");
    localStorage.setItem("PayPalPayment", true);

    let msg = "";
    if (this.props.renewal_flg && this.props.subscription_status === "ACTIVE")
      msg =
        "Subscription will be Renewed on the last day of current Subscription year. Please Note: You can also Renew space (Renew Space Button) in advance as your current space will be reset to 'Subscription Defaults' as part of Renewal";
    else if (
      this.props.renewal_flg &&
      this.props.subscription_status === "EXPIRED"
    )
      msg =
        "Subscription Renewed. Total & Available Space have been reset as per Subscription defaults. Please Note: You may need to purchase additional space depending on your Products previous consumption of space.";
    else msg = "Payment done Successfully";

    localStorage.setItem("PayPalPaymentMsg", msg);

    let uri = ENDPOINTS.user_subscriptions.capture.uri;
    let sub_count = this.props.sub_count;
    let price = this.props.price;
    let additional_users_flg = this.props.additional_users_flg;
    let renewal_flg = this.props.renewal_flg;
    return fetch(uri, {
      method: ENDPOINTS.user_subscriptions.capture.method,
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        paypal_order_id: data.orderID,
        sub_count: sub_count,
        price: price,
        additional_users_flg: additional_users_flg,
        renewal_flg: renewal_flg
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        window.location.reload();
        return data.pg_order_id;
      });
  };

  onSuccess = (details, data) => {
    if (renewal_flg && this.props.subscription_status === "ACTIVE")
      alert(
        "Subscription will be Renewed on the last day of current Subscription year. Please Note: You can also Renew space (Renew Space Button) in advance as your current space will be reset to 'Subscription Defaults' as part of Renewal"
      );
    else if (renewal_flg && this.props.subscription_status === "EXPIRED")
      alert(
        "Subscription Renewed. Total & Available Space have been reset as per Subscription defaults. Please Note: You may need to purchase additional space depending on your Products previous consumption of space."
      );
    else alert("payment done successfully");
  };

  onCancel = (data, actions) => {
    localStorage.removeItem("isSubscriptionPaid", "true");
    localStorage.removeItem("PayPalPayment", "true");
    alert("Payment cancelled");
  };

  onError = (data, actions) => {
    localStorage.removeItem("isSubscriptionPaid", "true");
    localStorage.removeItem("PayPalPayment", "true");
    alert("Something went wrong please try again later");
  };

  render() {
    const PaypalButton = window.paypal.Buttons.driver("react", {
      React,
      ReactDOM
    });
    return (
      <PaypalButton
        {...this.props}
        createOrder={this.createOrder}
        onApprove={this.onApprove}
        // onApprove={e => this.onApprove(e)}
        onSuccess={this.onSuccess}
        onError={this.onError}
        onCancel={this.onCancel}
        // style={style}
      />
    );
  }
}

export default SubscriptionPayment;
